// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getRegistrationHistory} from '../../shared/repositories';

export const updateRegistrationHistory = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getRegistrationHistory(pin);

            dispatch({
                payload,
                property: 'registrationHistoryList',
                type: actions.UPDATE_REGISTRATION_HISTORY_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/registration-history.js